import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import BuildIcon from '@material-ui/icons/Build';
import { getPartnersMaintenance } from '../../service/maintenance/selector';
import './style.scss';

/**
 * Grise et neutralise son contenu tant que la maintenance partenaires est
 * active (variable serveur `partnersMaintenance` sur la base MED).
 * Le contenu reste lisible, seules les interactions sont coupées.
 */
const MaintenanceGuard = ({ active, children }) => {
	if (!active) return <React.Fragment>{children}</React.Fragment>;

	return (
		<div className="maintenance-guard">
			<div className="maintenance-guard-banner">
				<BuildIcon />
				<div>
					<p className="maintenance-guard-banner-title">
						{I18n.t('maintenance.partners.title')}
					</p>
					<p className="maintenance-guard-banner-description">
						{I18n.t('maintenance.partners.description')}
					</p>
				</div>
			</div>
			<div className="maintenance-guard-content" aria-hidden="true">
				{children}
			</div>
		</div>
	);
};

const mapStateToProps = state => {
	return {
		active: getPartnersMaintenance(state),
	};
};

export default connect(mapStateToProps)(MaintenanceGuard);
